import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, of, tap } from "rxjs";

import { AUTH_SERVICE_TOKEN, AuthFacade } from "@coin-depo-core/auth";
import { VotingHistoryFacade } from "@coin-depo-core/governance";
import { StorageService } from "@coin-depo-core/storage";
import { ApiService } from "@coin-depo/http";

import { LanguageFacade } from "@coin-depo-i18n";

import type { GovernanceVotingHistoryParams, GovernanceVotingHistoryRequest } from "@coin-depo-types";



@Injectable({
    providedIn: 'root',
  })
export class GovernanceVotingHistoryService implements VotingHistoryFacade {
    protected storageKeyIsUserHasVoting = 'governanceisUserHasVoting';
    protected isUserHasVoting$ = new BehaviorSubject<boolean>(
        this.storage.get(this.storageKeyIsUserHasVoting, false)
    );
    cachedIsUserHasVoting$ = this.isUserHasVoting$.asObservable();

    protected storageKeyVotesList = 'votesList';
    protected votesList$ = new BehaviorSubject<any>(
        this.storage.get(this.storageKeyVotesList, null)
    );
    cachedVotesList$ = this.votesList$.asObservable();
    
    constructor(
        @Inject(AUTH_SERVICE_TOKEN) private auth: AuthFacade,
        private storage: StorageService,
        private api: ApiService,
        private translate: LanguageFacade,
    ) {}

    getGovernanceVotingHistory(params: GovernanceVotingHistoryParams) {
        const userData = this.auth.userData;
        console.log(this.translate.currentLang, 'governanceVotingHistory', params);
        
        const data: GovernanceVotingHistoryRequest = {
            ...params,
            client_token: this.auth.accessToken,
            username: userData.email,
            lang: this.translate.currentLang,
        };

        console.log(data);
        
        return this.api.getGovernanceVotingHistory(data)
        .pipe(
            tap(res => {
                if (res.status === 'success') {
                    this.setVotingHistory(res)
                }
            })
        )
    }

    private setVotingHistory(res: any) {
        this.isUserHasVoting$.next(res.is_user_has_voting);
        this.storage.set(this.storageKeyIsUserHasVoting, res.is_user_has_voting);

        const votesList = {
            total_count: res.total_count,
            total_pages: res.total_pages,
            res: res.res
        }
        this.votesList$.next(votesList);
        this.storage.set(this.storageKeyVotesList, votesList);
    }

    getIsUserHasVotingSnapshot(): boolean {
        return this.isUserHasVoting$.value;
    }

    getVotesListSnapshot(): any {
        return this.votesList$.value;
    }
}